import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PartNumber, PartNumberSearchViewModel } from "../partNumberManipulation/partNumberManipulation-viewModel";
import  { PartNumberCanReplaceManipulationView } from "./partNumberCanReplaceManipulation-view"
import { downloadFile } from "src/uicomponents/components/utilities";
import { FileSelectorViewModel } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class PartNumberCanReplaceManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return "تنظیم جایگزین های کدهای کالا";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.fromPartNumbers = ObservableArray.create<FromPartNumber>();
        this.toPartNumbers = ObservableArray.create<ToPartNumber>();
        this.fileSelector = new FileSelectorViewModel(this);
        this.fromPartNumberSelector = new PartNumberSearchViewModel(this);
        this.fromPartNumberSelector.onSelectionChanged = q=>{
            let r = new FromPartNumber(this);
            r.id = q.id;
            r.code = q.code;
            r.pncName = q.pncName;
            r.isSelected = false;
            if(this.fromPartNumbers.findIndex(o => o.id === r.id) === -1){
                this.fromPartNumbers.push(r)
            };
            this.selectFromPartNumber(r);
        }
        this.toPartNumberSelector = new PartNumberSearchViewModel(this);
        this.toPartNumberSelector.onSelectionChanged = q=>{
            let r = new ToPartNumber(this);
            r.id = q.id;
            r.code = q.code;
            r.pncName = q.pncName;
            r.choosed = true;
            r.undoRemove();
            if(this.toPartNumbers.findIndex(o => o.id === r.id) === -1 && r.id !== this.selectedFromPartNumber?.id)
                this.toPartNumbers.push(r);
        }

        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new PartNumberCanReplaceManipulationView();
    }
    public getTypeId(): string {
        return "VM-8D09476A-8FE6-4571-9536-E7DA77AA7151"
    }
    public set fromPartNumbers(v: ObservableArray<FromPartNumber>) { this._fromPartNumbers = v; } public get fromPartNumbers(): ObservableArray<FromPartNumber> { return this._fromPartNumbers;} private _fromPartNumbers: ObservableArray<FromPartNumber>;
    public set toPartNumbers(v: ObservableArray<ToPartNumber>) { this._toPartNumbers = v; } public get toPartNumbers(): ObservableArray<ToPartNumber> { return this._toPartNumbers;} private _toPartNumbers: ObservableArray<ToPartNumber>;
    public set selectedToPartNumber(v: PartNumber) { this._selectedToPartNumber = v; } public get selectedToPartNumber(): PartNumber { return this._selectedToPartNumber;} private _selectedToPartNumber: PartNumber;
    public set selectedFromPartNumber(v: FromPartNumber) { this._selectedFromPartNumber = v; } public get selectedFromPartNumber(): FromPartNumber { return this._selectedFromPartNumber;} private _selectedFromPartNumber: FromPartNumber;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set toPartNumberSelector(v: PartNumberSearchViewModel) { this._toPartNumberSelector = v; } public get toPartNumberSelector(): PartNumberSearchViewModel { return this._toPartNumberSelector;} private _toPartNumberSelector: PartNumberSearchViewModel;
    public set fromPartNumberSelector(v: PartNumberSearchViewModel) { this._fromPartNumberSelector = v; } public get fromPartNumberSelector(): PartNumberSearchViewModel { return this._fromPartNumberSelector;} private _fromPartNumberSelector: PartNumberSearchViewModel;
    public set needSave(v: boolean) { this._needSave = v; } public get needSave(): boolean { return this._needSave;} private _needSave: boolean;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;

    async refresh(){
        try {
            this.isLoading = true;
            this.fromPartNumbers.clear();
            this.toPartNumbers.clear();        
            this.needSave = false;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async save(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/WarehouseServices/SetCanReplacedBy', {
                FromPartNumberId: this.selectedFromPartNumber.id,
                ToPartNumbers: this.toPartNumbers.filter(x => x.choosed == true).map(x => x.id)
            });
            this.needSave = false;
            this.isLoading = false;
            this.getToPartNumbers();
            await this.messageBoxConfirmSuccess('جایگزین های کالا با موفقیت ثبت شد.', 'عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            this.isLoading = false;
        } finally {
            
        }
    }
    
    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ExportPartNumberReplaced',{
            });
            downloadFile(result.ExcelData, `export_part_numbers replaced.xlsx`);
            await this.messageBoxConfirmSuccess('فایل خروجی با موفقیت بارگذاری شد.','عملیات موفق');
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async importFromExcel(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ImportPartNumberReplaced',{
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful == false) {
                if (!stringIsNullOrEmpty(result.InvalidFileInfo)) {
                    downloadFile(result.InvalidFileInfo,'مشکلات.xlsx');
                    throw 'متن خطا در فایل دانلود شده است.';
                }
                throw 'خطا در انجام عملیات';
            }
            let preview = new ImportPreview(this);
            
            preview.importedPartNumbers.update(...result.PartNumbers.map(q=>{
                let r = new FromPartNumber(this);
                r.id = q.FromPartNumberId;
                r.code = q.Code;
                r.pncName = q.Name;
                r.toPartNumbers.update(...q.ToPartNumbers.map(q=>{
                    let r = new ToPartNumber(this);
                    r.id = q.PartNumberId;
                    r.code = q.Code;
                    r.pncName = q.Name;
                    return r;
            }));
                return r;
            }));
            this.showPopup(preview);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning(ex,'خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async getToPartNumbers() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/WarehouseServices/GetToPartNumbers', 
            {
                PartNumberId:this.selectedFromPartNumber.id
            });
            this.toPartNumbers.update(...result.ToPartNumbers.map(q=>{
                let r = new ToPartNumber(this);
                r.id = q.Id;
                r.code = q.Code;
                r.pncName = q.PncName;
                r.choosed = true;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    setNeedSave(){
        this.needSave = true;
    }

    async selectFromPartNumber(selectedPartNumber: FromPartNumber) {
        if (this.needSave)
        {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','تغییرات ذخیره نشده شما از بین می رود.');
            if(result=='yes'){
                this.fromPartNumbers.forEach(x=>x.isSelected = false);
                selectedPartNumber.isSelected = true;
                this.selectedFromPartNumber = selectedPartNumber;
                this.getToPartNumbers();            
                this.needSave = false;
            }
        } else {
            this.fromPartNumbers.forEach(x=>x.isSelected = false);
            selectedPartNumber.isSelected = true;
            this.selectedFromPartNumber = selectedPartNumber;
            this.getToPartNumbers();
        }
    }
    
}

export class ImportPreview extends ViewModel implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PartNumberCanReplaceManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.importedPartNumbers = ObservableArray.create<FromPartNumber>();
    }
    private _typedParent : PartNumberCanReplaceManipulationViewModel;
    closePopup() {}
    
    public set importedPartNumbers(v: ObservableArray<FromPartNumber>) { this._importedPartNumbers = v; } public get importedPartNumbers(): ObservableArray<FromPartNumber> { return this._importedPartNumbers;} private _importedPartNumbers: ObservableArray<FromPartNumber>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    
    async import(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/BulkSetPartNumberReplaced',{
                PartNumbers : this.importedPartNumbers.map(p => {
                    return {
                        FromPartNumberId: p.id,
                        ToPartNumbers: p.toPartNumbers.map(i => {
                            return {
                                PartNumberId: i.id
                            };
                        })
                    }
                })
            });
            if (result.IsSuccessful == false) {
                throw 'error';
            }
            await this.messageBoxConfirmSuccess('کد کالاهای جایگزین با موفقیت بروزسانی شد.','عملیات موفق');
            this.closePopup();
            this._typedParent.refresh();
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class FromPartNumber extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PartNumberCanReplaceManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.toPartNumbers = ObservableArray.create<ToPartNumber>();
    }
    private _typedParent : PartNumberCanReplaceManipulationViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    public set toPartNumbers(v: ObservableArray<ToPartNumber>) { this._toPartNumbers = v; } public get toPartNumbers(): ObservableArray<ToPartNumber> { return this._toPartNumbers;} private _toPartNumbers: ObservableArray<ToPartNumber>;
    
    selectFrom(){
        this._typedParent.selectFromPartNumber(this);
    }
}

export class ToPartNumber extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PartNumberCanReplaceManipulationViewModel) {
        super(parent);
        this.typedParent = parent;
    }

    private typedParent: PartNumberCanReplaceManipulationViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set choosed(v: boolean) { this._choosed = v; } public get choosed(): boolean { return this._choosed;} private _choosed: boolean;
    
    undoRemove(){
        this.choosed = true; 
        this.typedParent.setNeedSave();
    }
    tryRemove(){
        this.choosed = false; 
        this.typedParent.setNeedSave();

    }
}
